export default __webpack_public_path__ + "static/media/pen.d82a43c7.svg";